export const cognitoClientId = '7hnehh7ktjuf8elmt3vtkh3t5f';
export const cognitoPoolId = 'eu-west-1_QzhrZWE5L';
export const cognitoRegion = 'eu-west-1';
export const cognitoDomain = 'netezon-wassalons-int.auth.eu-west-1.amazoncognito.com';
